"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var enums_1 = require("../../enums");
var react_1 = __importStar(require("react"));
var Button_1 = require("../Button");
var List = function (props) {
    var _a = (0, react_1.useState)(false), isAllItemsVisible = _a[0], setIsAllItemsVisible = _a[1];
    var defaultVisible = props.defaultVisible || 2;
    var count = react_1.default.Children.count(props.children);
    var split = [];
    react_1.default.Children.forEach(props.children, function (child, i) {
        if (i <= defaultVisible - 1) {
            split.push(child);
        }
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("ul", __assign({ className: "sdi-list ".concat(props.className || "") }, { children: [!isAllItemsVisible && count > defaultVisible && split, (isAllItemsVisible || count <= defaultVisible) && props.children] })), count > defaultVisible && ((0, jsx_runtime_1.jsx)(Button_1.Button, __assign({ className: "px-0", type: Button_1.ButtonTypes.LINK, size: enums_1.UiSizes.XXS, onClick: function () { return setIsAllItemsVisible(!isAllItemsVisible); } }, { children: isAllItemsVisible ? props.showLessLabel : props.showMoreLabel })))] }));
};
exports.List = List;
